<script>
import {dom, Platform} from "quasar"
import {computed, inject, onMounted, ref, nextTick, toRef} from "vue";
import {useStore} from "vuex";
import {getRandomString , isEmpty} from '@/tools/utils';
import {getDateInfo} from "../../../tools/utils";
import setColDialog from '@/components/pieces/dialog/set-col-diaog.vue';
import {tableColResize} from '@/tools/table-drag';
// import subsitutesDialog from '../components/substitutes-dialog';
export default {
  name: 'piece-base-table',
  inject: ['madData'],
  props:{
    tableTitle:{
      type:String,
      default:()=>{
        return ''
      }
    },
    tableSource:{
      type:Object,
      default:()=>{
        return {}
      }
    },
  },
  created() {
    this.init_table()
  },
  components:{
    setColDialog,
    // subsitutesDialog
  },
  computed: {
    source_pages() {
      let tot = this.tableSet.pagination ? this.tableSet.pagination.count : this.tableSet.data.length
      let rowpage = parseInt(this.pagination.rowsPerPage)
      let pages = parseInt((tot - 1 + rowpage) / rowpage)
      return pages
    },
    showColumns() {
      return this.tableSet.columns.filter(it => {
        return it.required
      })
    }
  },
  setup(props, context){
    const ADD_TYPE = ["number",'int'];
    const store = useStore();
    let tableSet = toRef(props, 'tableSource');
    let tableKey = ref(getRandomString(8))
    let addType = ref(ADD_TYPE);
    let isRowEdit = ref(false);
    let editCell = ref(
        {
          rowIndex:'',
          colName:''
        }
    )
    let myRef = ref();
    let myTbale = ref();
    let myDateProxy = ref();
    let subsitutesDialogRef = ref();
    const showTableColumns = computed(() => {
      return tableSet.value.columns.filter(it => {
        return it.check
      })
    });
    const bottomAddRow = computed(() => {
      let addRow=[];
      tableSet.value.data.forEach((row)=>{
        showTableColumns.value.forEach((col,colIndex)=>{
          if(col.isAddCol){
            if(isEmpty(addRow[colIndex])){
              addRow[colIndex] = 0
            }
            if(!isEmpty(row[col.field])){
              addRow[colIndex] = Number(addRow[colIndex]) + Number(row[col.field])
            }
            if(col?.type == 'int'){
              addRow[colIndex] = Number(addRow[colIndex]).toFixed(2)
            }
          }else{
            addRow[colIndex] = '';
          }
        })
      });
      return addRow
    });
    const tableStyle = computed(() => {
      if (!tableSet.value.isFullscreen) {
        let dic = {}
        if (tableSet.value.height && tableSet.value.height.length) {
          dic['height'] = tableSet.value.height
        }
        if (tableSet.value.maxHeight && tableSet.value.maxHeight.length) {
          dic['max-height'] = tableSet.value.maxHeight
        }
        return dic;
      }
      return {};
    });
    function inputBlur(env,props){
      context.emit('handleBlur',{value:tableSet.value.data[props.rowIndex][props.col.name],props})
    }
    function intInputBlur(env,props){
      if(isNaN(Number(env.target['_value']))){
        tableSet.value.data[props.rowIndex][props.col.name] = ''
      }else{
        tableSet.value.data[props.rowIndex][props.col.name] = Number(env.target['_value']);
      }
      context.emit('handleBlur',{value:tableSet.value.data[props.rowIndex][props.col.name],props})
    }
    function toggleFullscreen(prop){
      tableSet.value.isFullscreen = !tableSet.value.isFullscreen
      prop.toggleFullscreen();
    }
    function searchDialogOpen(props){
      context.emit('searchDialogOpen',props)
    }
    function rowIconClick(props){
      context.emit('rowIconClick',props)
    }
    function pasteInfo(e) {
      try {
        var data = null;
        var clipboardData = e.clipboardData;
        //复制过来的内容
        data = clipboardData.getData("Text");
        let rowStrArray = data.split("\n"); //根据换行拆分成数组
        let rowsInfo = [];
        for (let i = 0; i < rowStrArray.length; i++) {
          let row = [];
          let tdStrArray = rowStrArray[i].split("\t"); //按列拆分
          for (let j = 0; j < tdStrArray.length; j++) {
            row.push(tdStrArray[j]);
          }
          rowsInfo.push(row);
        }
        let list = [];
        if (rowsInfo.length) {
          //复制的数据二维数组转成一维数组
          list = rowsInfo.reduce((total, currentValue) => {
            return total.concat(currentValue);
          });
        } else {
          //粘贴单个
          list = rowStrArray;
        }
        context.emit('copy',{copyList:list,editCell})
      } catch (err) {
        console.log('请正确复制一列表格数据',err);
      }
    }
    function popupProxyClick(env){
      isRowEdit.value = true;
    }
    function cellClick(props){
      editCell.value.rowIndex = props.rowIndex;
      editCell.value.colName = props.col.field;
      isRowEdit.value = true;
      if (props.col.edit) {
        nextTick(() => {
          if(['input','number'].includes( props.col.type)){
            myRef.value.focus();
            myRef.value.select();
          }
        });
      }
    }
    function update(value){
      try{
        if(value.length > 2){
          store.dispatch('madValueSet/getFMLFBList',value);
        }
      }catch (e){
        console.log(e);
      }
    }
    function dateClick(props){
      myRef.value.focus();
      myDateProxy.value.show();
    }
    function isValueEmpty(value){
      return isEmpty(value);
    }
    let setColDialog = ref();
    function openColSetDialog(){
      setColDialog.value.openFun();
    }
    function showSubstitutes(prop){
      subsitutesDialogRef.value.openFun();
    }
    onMounted(()=>{
      window.onclick= (env) => {
        if(!isRowEdit.value){
          editCell.value.rowIndex = '';
          editCell.value.colName = '';
        }
        isRowEdit.value = false;
      };
    })
    return {
      rowIconClick,
      tableStyle,
      inputBlur,
      intInputBlur,
      tableKey,
      toggleFullscreen,
      addType,
      bottomAddRow,
      showTableColumns,
      searchDialogOpen,
      cellClick,
      editCell,
      isRowEdit,
      myRef,
      myTbale,
      myDateProxy,
      popupProxyClick,
      pasteInfo,
      update,
      isValueEmpty,
      dateClick,
      openColSetDialog,
      setColDialog,
      showSubstitutes,
      subsitutesDialogRef,
      tableSet
    }
  },
  data() {
    return {
      filterValue:'',
      data: [],
      dense: true,
      loading: false,
      pagination: {
        rowsPerPage: 0,
        page: this.tableSet?.pagination ? parseInt(this.tableSet?.pagination?.page) : 1,
      },
      table_height: '100%',
      selected: [],
    }
  },
  watch: {
    tableSet: {
      handler(v) {
        if (v.data != this.data) { //防止递归更新
          this.data = JSON.parse(JSON.stringify(v.data))
        }
      },
      deep: true
    },
    pagination: {
      handler(v) {
        localStorage.setItem('DEFAULT-PAGE-SIZE', v.rowsPerPage)
        if (this.tableSet.pagination) {
          let loc = this.tableSet.fetch_type[0] + '/' + this.tableSet.fetch_type[1]
          this.$store.dispatch(loc, v.page)
        }
      },
      deep: true
    },
    data: {
      handler(v) {
        if (this.tableSet.updated) {
          let loc = this.tableSet.updated[0] + '/' + this.tableSet.updated[1]
          this.$store.dispatch(loc, {data: v})
        }
      },
      deep: true
    },
    selected: {
      handler(v) {
        if (this.tableSet.updated) {
          let loc = this.tableSet.updated[0] + '/' + this.tableSet.updated[1]
          this.$store.dispatch(loc, {selected: v})
        }
        if (this.tableSet.selected_change) {
          let loc = this.tableSet.selected_change[0] + '/' + this.tableSet.selected_change[1]
          this.$store.dispatch(loc, v)
        }
      },
      deep: true
    }
  },
  methods: {
    init_table() {
      let tb = this.tableSet
      tb.visibleColumns = []
      tb.columns.forEach(it => {
        if (this.$q.platform.is.mobile) {
          it.check = it.required ? true : false
        }
        if (it.check) {
          tb.visibleColumns.push(it.name)
        }
      })
    },
    set_table_height() {
      if (!Platform.is.mobile) {
        this.table_height = window.innerHeight - dom.offset(this.$refs.data_q_table).top - 45 + 'px'
      }
    },
    onRowSelection(evt){
      this.$emit("select", {rows:evt.rows,added:evt.added,type:'select'});
    },
    selectCol(key = '') {
      this.tableSet.visibleColumns = []
      let cols = this.tableSet.columns
      cols.forEach(it => {
        if (it.name === key) {
          it.check = !it.check
        }
        if (it.check) {
          this.tableSet.visibleColumns.push(it.name)
        }
      })
    },
    optionsFn (date) {
      let today = getDateInfo().dateInfo;
      let dateObj = getDateInfo(today);
      let dateArr = date.split('/');
      let inputDate=getDateInfo(dateArr[0]+'-'+dateArr[1]+'-'+dateArr[2]);
      return inputDate.time >= dateObj.time;
    },
    setSelected(arrData){
      this.selected = arrData;
    },
    tool_click(item) {
      this.isRowEdit = true;
      this.$emit("tool_click", item.sign);
    },
    popupProxyShow(env,prop){
      this.filterValue = this?.tableSet?.data?.[prop.rowIndex]?.[prop.col.name] || '';
      this.$nextTick(()=>{
        this.$refs['inputSelect'+prop.rowIndex+prop.col.field+'test'].focus();
      })
    },
    showInptSelect(value,prop,madArr){
      let arrData = madArr[prop.col.field] || [];
      return arrData
    },
    inputSelectRowClick(evt, row, index,props){
      this.$emit('selectRow',{rows:[row],props})
      this.$refs['myPopupProxy'+props.rowIndex+props.col.field].hide();
    },
    startResize(event,props){
      tableColResize(event,props,this.tableSet.columns,{leftYl:48});
    }
  },
  mounted() {
    if(!isEmpty(this.tableSet.selected)){
      this.selected = this.tableSet.selected;
    }
  }
}
</script>
<template>
  <div ref="data_q_table">
    <q-table
        ref="myTbale"
        separator="cell"
        :key="tableKey"
        :dense="dense"
        square flat color="primary"
        :rows="data"
        :row-key="tableSet.row_key"
        :columns="showTableColumns"
        v-model:pagination="pagination"
        :hide-pagination="tableSet.pagination?false:true"
        virtual-scroll
        :virtual-scroll-sticky-size-start="48"
        :loading="loading"
        :visible-columns="tableSet.visibleColumns"
        :selection="tableSet.selection"
        v-model:selected="tableSet.selected"
        hide-selected-banner
        @selection ="onRowSelection"
        @resize="set_table_height"
        :style="tableStyle"
        @paste.enter.capture.prevent="pasteInfo($event)"
        class="my-custom-table"
        :class="tableSet.table_class?tableSet.table_class:'base-table'"
        :card-class="'table-border sticky-table-container'+(tableSet.selection != 'none' ? ' my-sticky-header-column-table':'')"
    >
      <template v-slot:header-cell="props">
        <q-th :props="props" :style="props.col.style ? props.col.style : ''"  :class="props.col.class">
          {{ props.col.label}}
          <q-icon :class="props.col.icon" style="font-size:16px; color:gray;" v-if="props.col.icon">
            <q-tooltip anchor="top middle" self="bottom middle" v-if="props.col.icontip">
              <div v-for="(tip, index) in tipToArr(props.col.icontip)" :key="index">
                {{ tip }}
                <br v-if="index < props.col.icontip.length - 1">
              </div>
            </q-tooltip>
          </q-icon>
          <div class="my-table-resizer" @click.stop @mousedown.prevent="(evnt)=>startResize(evnt,props)"></div>
        </q-th>
      </template>
      <template v-slot:body-cell="props">
        <q-td :props="props" @click="cellClick(props)" :class="{'no-edit-bg': !props.col.edit,'no-edit-bg-empty':props.col.edit}">
          <span v-if="props.col.edit && editCell.rowIndex == props.rowIndex && editCell.colName == props.col.field">
            <q-input v-if="props.col.type == 'input'" borderless  @blur="(env)=>inputBlur(env,props)" :input-class="props.col.class" style="width:auto" v-model="tableSet.data[props.rowIndex][props.col.name]"
                     dense ref='myRef'/>
            <q-input v-if="props.col.type == 'number'" borderless  @blur="(env)=>intInputBlur(env,props)" :input-class="props.col.class" style="width:auto" v-model="tableSet.data[props.rowIndex][props.col.name]"
                     dense ref='myRef'>
              <template v-slot:after>
                <q-icon v-if="props.col.isClickIcon" :title="props.col.iconTitle" :name="props.col.iconName" :class="props.col.iconClass" @click="rowIconClick(props)"/>
              </template>
            </q-input>
            <q-select v-if="props.col.type == 'select'" @blur="(env)=>inputBlur(env,props)" class="my-select" dense outlined filled transition-show="jump-up" transition-hide="jump-up" options-dense
                      v-model="tableSet.data[props.rowIndex][props.col.name]" :options="props.col.options" emit-value map-options ref='myRef'>
            </q-select>
            <q-input v-if="props.col.type == 'inputSelect'" borderless  @blur="(env)=>inputBlur(env,props)" :input-class="props.col.class" style="width:auto" v-model="tableSet.data[props.rowIndex][props.col.name]" dense ref='myRef'>
              <template v-slot:after>
                <q-icon name="fas fa-search" class="serch-icon" @click="searchDialogOpen(props)"/>
              </template>
                <q-popup-proxy @show="(env)=>popupProxyShow(env,props)" :ref="'myPopupProxy'+props.rowIndex+props.col.field">
                  <span @click="popupProxyClick">
                    <span style="padding: 5px">
                    <q-input :ref="'inputSelect'+props.rowIndex+props.col.field+'test'" :input-class="props.col.class" style="width:auto" v-model="filterValue"
                             @update:model-value="update"
                             dense outlined></q-input>
                    <q-table :hide-pagination="true" dense :columns="[
                                  {name: 'FMLFB',field: 'FMLFB',label: '订货号',style: 'min-width: 100px',align: 'center'},
                                  {name: 'FBrand',field: 'FBrand',label: '品牌',style: 'min-width: 100px',align: 'center'},
                                  {name: 'FErpMaterialNumber',field: 'FErpMaterialNumber',label: 'ERP物料编码',style: 'min-width: 110px',align: 'center'},
                                  {name: 'FMaterialName',field: 'FMaterialName',label: '物料名称',style: 'min-width: 100px',align: 'center'},
                                  {name: 'FModel',field: 'FModel',label: '规格型号',style: 'min-width: 100px',align: 'center'},
                                  ]"
                             @row-click="(evt, row, index)=>inputSelectRowClick(evt, row, index,props)"
                             :rows="showInptSelect(filterValue,props,madData)">
                    </q-table>
                   </span>
                  </span>
                  </q-popup-proxy>
            </q-input>
            <q-input class="l" v-if="props.col.type == 'date'" borderless v-model="tableSet.data[props.rowIndex][props.col.name]" @update:model-value="(value)=>inputBlur(value,props)" dense square clearable ref='myRef'>
              <template v-slot:after>
                <q-icon name="fas fa-calendar-alt" class="serch-icon" @click="dateClick(props)"/>
              </template>
              <q-popup-proxy ref="myDateProxy" transition-show="scale" transition-hide="scale">
                <q-date :options="optionsFn" v-model="tableSet.data[props.rowIndex][props.col.name]" @click="cellClick(props)" @update:model-value="(value)=>inputBlur(value,props)" mask="YYYY-MM-DD"></q-date>
              </q-popup-proxy>
            </q-input>
          </span>
          <span v-else-if="props.col.field == 'FKtdsp'" style="text-align: center">
            <q-icon v-if="tableSet.data[props.rowIndex][props.col.name]" name="fas fa-check-square" size="18px" class="cursor-pointer text-primary" @click="showSubstitutes(props)"></q-icon>
          </span>
          <span v-else-if="props.col.field == 'serialCol'">
            {{props.rowIndex+1}}
          </span>
          <span v-else-if="!isValueEmpty(props.row['sign']) && tableSet.signCol.includes(props.col.field)" :class="{'warning-font':props.row['sign']=='warning','success-font':props.row['sign']=='success','error-font':props.row['sign']=='error'}">
             {{isValueEmpty(props.value)|| props.value == 'undefined' || props.value == 'null'?'': props.value}}
          </span>
          <span v-else>
            {{isValueEmpty(props.value)|| props.value == 'undefined' || props.value == 'null'?'': props.value}}
          </span>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <tr style="background: #F7F7F7 !important;">
          <td class="q-table--col-auto-width" v-if="tableSet.selection != 'none'" style="background-color: #F7F7F7 !important;border-top:1px solid #e0e0e0;">
            合计
          </td>
          <td v-for="(col,index) in showTableColumns" :key="col.name+index" class="q-table--col-auto-width" style="border-top:1px solid #e0e0e0;" :style="tableSet.selection == 'none' && index==0 ? 'text-align:left;':'text-align:right;'">
            {{tableSet.selection == 'none' && index==0 ? '合计' : (addType.indexOf(col.type) != -1 &&  col.isAddCol? bottomAddRow[index] : '')}}
          </td>
        </tr>
      </template>
      <template v-slot:body-cell-table__index="props">
        <q-td :props="props">
          {{ props.rowIndex + 1 }}
        </q-td>
      </template>
      <!--      <template v-slot:top="props" v-if="tableTitle">-->
      <!--        <q-toolbar class="bg-grey-2">-->
      <!--          <span class="q-ml-sm">{{ tableTitle ? tableTitle : '' }}</span>-->
      <!--          <q-space/>-->
      <!--          <div class="q-gutter-sm text-right">-->
      <!--            <q-btn v-for="item in tableSet.tools.buttons" :key="item.index" rounded flat dense size="md"-->
      <!--                   :icon="item.icon" color="primary" @click="tool_click(item)">-->
      <!--              <q-tooltip anchor="top middle" self="bottom middle">{{ item.label }}</q-tooltip>-->
      <!--            </q-btn>-->
      <!--            <q-btn rounded flat dense size="md" icon="fas fa-columns" color="primary">-->
      <!--              <q-tooltip anchor="top middle" self="bottom middle">设置显示列</q-tooltip>-->
      <!--              <q-menu :offset="[0, 12]">-->
      <!--                <q-list dense>-->
      <!--                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"-->
      <!--                          @click="selectCol(column.name)">-->
      <!--                    <q-item-section>{{ column.label }}</q-item-section>-->
      <!--                  </q-item>-->
      <!--                </q-list>-->
      <!--              </q-menu>-->
      <!--            </q-btn>-->
      <!--            <q-btn rounded color="primary" flat round dense-->
      <!--                   :icon="props.inFullscreen ? 'fas fa-compress' : 'fas fa-expand'"-->
      <!--                   @click="toggleFullscreen(props)">-->
      <!--              <q-tooltip anchor="top middle" self="bottom middle">全屏</q-tooltip>-->
      <!--            </q-btn>-->
      <!--          </div>-->
      <!--        </q-toolbar>-->
      <!--      </template>-->
      <template v-slot:top="props" v-if="tableSet?.tools?.isShow">
        <q-toolbar class="bg-grey-2">
          <span class="q-ml-sm">{{ tableTitle ? tableTitle : '' }}</span>
          <q-space/>
          <div class="q-gutter-sm text-right">
            <q-btn v-for="item in tableSet.tools.buttons" class="my-text-btn" :label="item.label" :key="item.index" flat dense size="xl" :disable="item.disable"
                   @click="tool_click(item)" :class="{'btn-checked':item.isHasCheckedType && item.isChecked}">
            </q-btn>
            <q-btn flat dense size="xl" label="设置显示列" @click="openColSetDialog" class="my-text-btn">
            </q-btn>
            <!--            <q-btn flat dense size="xl" label="设置显示列" class="my-text-btn">-->
            <!--              <q-menu :offset="[0, 12]">-->
            <!--                <q-list dense>-->
            <!--                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"-->
            <!--                          @click="selectCol(column.name)">-->
            <!--                    <q-item-section>{{ column.label }}</q-item-section>-->
            <!--                  </q-item>-->
            <!--                </q-list>-->
            <!--              </q-menu>-->
            <!--            </q-btn>-->
            <q-btn :label="props.inFullscreen ? '缩小' : '全屏'" flat dense class="my-text-btn"
                   @click="toggleFullscreen(props)">
            </q-btn>
          </div>
        </q-toolbar>
      </template>
      <template v-slot:bottom="scope" v-if="tableSet.pagination">
        <q-toolbar>
          <div class="q-gutter-sm text-body2">
            <div class="inline-block">
              每页行数：
              <span class="inline-block">
                            <q-select v-model="pagination.rowsPerPage" dense
                                      :options="tableSet.pagination&&tableSet.pagination.perpage?tableSet.pagination.perpage:[10,20,50,100,500,1000]"/>
                        </span>
            </div>
            <div class="inline-block q-mx-sm items-center">
              <div class="inline-block">总行数：</div>
              <div class="inline-block">
                <q-badge color="primary" align="middle">
                  {{
                    tableSet.pagination ? (tableSet.pagination.count ? tableSet.pagination.count : tableSet.data.length) : data.length
                  }}
                </q-badge>
              </div>
            </div>
            <div class="inline-block">
                    <span class="inline-block">
                      跳转至：
                    </span>
              <span class="inline-block">
                        <q-input type="number" dense :filled="tableTitle!=''" :outlined="tableTitle!=''"
                                 v-model.number="pagination.page" style="width:60px;"/>
                      </span>
              <span class="inline-block text-body2">
                      /{{ source_pages }}页
                    </span>
            </div>
            <div class="inline-block">
              <q-pagination v-model="pagination.page" color="primary" :max="scope.pagesNumber"
                            size="12px" :max-pages="4" :boundary-numbers="false" :boundary-links="true"
                            class="q-mt-sm q-px-sm"/>
            </div>
          </div>
          <q-space/>
          <div class="q-gutter-sm text-right" v-if="!tableTitle">
            <q-btn rounded flat dense size="md" icon="fas fa-columns" color="primary">
              <q-tooltip anchor="top middle" self="bottom middle">设置显示列</q-tooltip>
              <q-menu :offset="[0, 12]">
                <q-list dense>
                  <q-item clickable v-for="(column, index) in tableSet.showColumns" :key="index" :active="column.check"
                          @click="tableSet.selectCol(column.name)">
                    <q-item-section>{{ column.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <q-btn rounded flat dense size="md" icon="fas fa-table" color="primary" @click="dense=!dense">
              <q-tooltip anchor="top middle" self="bottom middle">密集表格</q-tooltip>
            </q-btn>
            <q-btn rounded color="primary" flat round dense
                   :icon="scope.inFullscreen ? 'fas fa-compress' : 'fas fa-expand'"
                   @click="scope.toggleFullscreen">
              <q-tooltip anchor="top middle" self="bottom middle">全屏</q-tooltip>
            </q-btn>
          </div>
        </q-toolbar>
      </template>
    </q-table>
    <set-col-dialog ref="setColDialog" :tableSet="tableSet"></set-col-dialog>
<!--    <subsitutes-dialog ref="subsitutesDialogRef"></subsitutes-dialog>-->
  </div>
</template>
<style lang="scss" scoped>
.warning-font{
  color:#F2C037
}
.success-font{
  color:#21BA45
}
.error-font{
  color: #C10015;
}
/* 关键：固定选择列宽度为48px */
::v-deep.my-custom-table th:first-child,
::v-deep.my-custom-table td:first-child {
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  padding-left: 0;
  padding-right: 0;
}

/* 确保复选框居中 */
::v-deep.my-custom-table td:first-child .q-checkbox {
  display: flex;
  justify-content: center;
  width: 100%;
}
.sticky-table-container {
  position: relative;
  overflow: auto;
  // 固定列公共样式
  .emis-sticky-column {
    z-index: 3 !important;
  }
}
.table-border{
  ::v-deep .q-table__middle {
    border: 1px solid #e0e0e0 !important;
  }
  ::v-deep .q-table{
    border-bottom:1px solid #e0e0e0;
  }
  ::v-deep .q-table thead tr th{
    background-color: #E2E7EF;
    text-align: center;
  }
  //::v-deep .q-table tbody tr td:first-child{
  //  background-color: white;
  //}
  ::v-deep.q-table--dense .q-table__top {
    padding: 6px 0px;
  }
  .no-edit-bg{
    background-color: #F7F7F7;
  }
  .no-edit-bg-empty{
    background-color: white;
  }
}

::v-deep .q-toolbar {
  min-height: 33px;
}

::v-deep .q-btn .q-icon {
  font-size: 22px !important;
}
::v-deep.my-select .q-field__native{
  min-height: 0px;
}
.btn-checked{
  border: 1px solid;
}
.serch-icon{
  cursor: pointer;
}
.my-text-btn:hover{
  color: #42A5F5;
}
</style>
<style lang="sass" scoped>
.my-sticky-header-column-table
  tr th
    position: sticky
    /* higher than z-index for td below */
    z-index: 2
    /* bg color is important; just specify one */
    background: #fff

  /* this will be the loading indicator */
  thead tr:last-child th
    /* height of all previous header rows */
    top: 48px
    /* highest z-index */
    z-index: 3
    width: 48px !important
  thead tr:first-child th
    top: 0
    z-index: 1
  tr:first-child th:first-child
    /* highest z-index */
    z-index: 3

  td:first-child
    z-index: 1

  td:first-child, th:first-child
    position: sticky
    left: 0
</style>
